var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobalSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22 12c0-5.52-4.48-10-10-10s-10 4.48-10 10 4.48 10 10 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.99998 3h1c-1.95 5.84-1.95 12.16 0 18h-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 3c.97 2.92 1.46 5.96 1.46 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 16v-1c2.92.97 5.96 1.46 9 1.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 9.0001c5.84-1.95 12.16-1.95 18 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.2 21.4c1.7673 0 3.2-1.4327 3.2-3.2s-1.4327-3.2-3.2-3.2-3.2 1.4327-3.2 3.2 1.4327 3.2 3.2 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 22-1-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalSearch);
export default __webpack_public_path__ + "static/media/global-search.fffb570ba7ee388344e7eb21aea87a09.svg";
export { ForwardRef as ReactComponent };